import React, {useState} from 'react';
import {toast} from 'react-toastify';
import {Form, Input} from 'antd';
import {setIsLoggedIn, setRole} from '../slices/app';
import {useNavigate} from 'react-router-dom';
import Modal from 'react-modal';
import api from '../Interceptor';
import {getRoute} from '../api/routes';
import {useDispatch} from 'react-redux';
import CustomModal from './customModal/customModal';
import ModalFooter from './customModal/modalFooter';
import useModal from '../hooks/useModal';
const UserLoggedInUserPopup = ({onMenuSelect, onPopoverVisible}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {isOpen, toggleModal} = useModal();
  const handleLogout = () => {
    // localStorage.removeItem("name");
    // localStorage.removeItem("accessToken");
    // localStorage.removeItem("refreshToken");
    // localStorage.removeItem("tokenExpiresIn");
    // localStorage.removeItem("role");
    // localStorage.removeItem("baseCurrency");
    // localStorage.removeItem("id");
    // localStorage.removeItem("email");
    // localStorage.removeItem("parentId");
    // localStorage.removeItem("parentName");
    localStorage.clear();
    toast.success('Logged out successfully!');
    dispatch(setIsLoggedIn(false));
    dispatch(setRole(''));
    setTimeout(() => {
      navigate('/', {replace: true});
    }, 1000);
  };
  const handleSavePassword = async (values) => {
    const {oldPassword, newPassword, confirmPassword} = values;
    if (newPassword !== confirmPassword) {
      toast.error('The two new passwords do not match!');
      return;
    }
    try {
      const response = await api.put(
        getRoute('users', 'user', 'self', false, false, 'updatePassword'),
        {oldPassword, newPassword, confirmPassword}
      );

      if ((response.status = 200)) {
        toast.success('Password updated successfully!');
        toggleModal();
      } else {
        toast.error(
          response.data?.error || response.error || 'Failed to update password'
        );
      }
    } catch (error) {
      const message =
        error.response?.data?.error ||
        error.message ||
        'Error updating password';
      toast.error(message);
    }
  };

  return (
    <div className="w-52 bg-white">
      <div
        className="flex justify-between items-center cursor-pointer"
        onClick={() => {
          toggleModal();
          if (onMenuSelect) onMenuSelect();
          if (onPopoverVisible) onPopoverVisible();
        }}
      >
        <span>Update Password</span>
        <i className="fa-solid fa-angle-right"></i>
      </div>
      <div
        className="text-[#EB4143] border-t border-gray-300 mt-2 pt-2 text-center cursor-pointer"
        onClick={handleLogout}
      >
        <i className="fa-solid fa-arrow-right-from-bracket me-2"></i>Logout
      </div>

      <CustomModal
        isOpen={isOpen}
        onClose={toggleModal}
        modalTitle="Update Password"
      >
        <Form onFinish={handleSavePassword}>
          <Form.Item
            name="oldPassword"
            rules={[
              {required: true, message: 'Please input your old password!'},
            ]}
            className="mb-4"
          >
            <Input.Password
              placeholder="Old Password"
              className="w-full py-2 px-3 rounded-lg border border-gray-300"
            />
          </Form.Item>
          <Form.Item
            name="newPassword"
            rules={[
              {required: true, message: 'Please input your new password!'},
            ]}
            className="mb-4"
          >
            <Input.Password
              placeholder="New Password"
              className="w-full py-2 px-3 rounded-lg border border-gray-300"
            />
          </Form.Item>
          <Form.Item
            name="confirmPassword"
            rules={[
              {required: true, message: 'Please confirm your new password!'},
              ({getFieldValue}) => ({
                validator(_, value) {
                  if (!value || getFieldValue('newPassword') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error('The two passwords do not match!')
                  );
                },
              }),
            ]}
            className="mb-4"
          >
            <Input.Password
              placeholder="Confirm New Password"
              className="w-full py-2 px-3 rounded-lg border border-gray-300"
            />
          </Form.Item>
          <ModalFooter onCancel={toggleModal} />
        </Form>
      </CustomModal>
    </div>
  );
};

export default UserLoggedInUserPopup;
